// extracted by mini-css-extract-plugin
export default {"contaner":"contaner__-1f74862d","heading":"heading__-1f74862d","subheading":"subheading__-1f74862d"};